import React from 'react';

import {Button, Icon, Menu, Text} from '@albert-io/atomic';

import type {SelectOption} from '../types';

interface FilterSelectDropdownProps<T extends string> {
  label: string;
  value: T;
  options: ReadonlyArray<SelectOption<T>>;
  onChange: (value: T) => void;
  testId?: string;
}

/** Single-select filter dropdown (Status, Created By, …). */
export const FilterSelectDropdown = <T extends string>({
  label,
  value,
  options,
  onChange,
  testId
}: FilterSelectDropdownProps<T>) => (
  <Menu closeOnItemClick position='bottom-end' positionFixed>
    <Menu.Trigger>
      {(triggerProps) => (
        <Button {...triggerProps} color='secondary' variant='outlined' data-testid={testId}>
          <Text color='inherit'>{label}</Text>
          <Icon icon='caret-down' className='ml-x1' />
        </Button>
      )}
    </Menu.Trigger>
    <Menu.Content>
      {options.map((option, index) => (
        <React.Fragment key={option.value}>
          {index === 1 && <Menu.Divider />}
          <Menu.Item
            selected={value === option.value}
            rightIconProps={value === option.value ? {icon: 'check'} : undefined}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Menu.Item>
        </React.Fragment>
      ))}
    </Menu.Content>
  </Menu>
);
